export const MOBILE_NAV = {
  BAR: "mobile-bottom-navigation",
  HOME: "mobile-nav-home",
  SEARCH: "mobile-nav-search",
  WARDROBE: "mobile-nav-wardrobe",
  CART: "mobile-nav-cart",
  PROFILE: "mobile-nav-profile",
};
